var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.8,
    r: 12,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63749 14.1501C7.99999 14.0532 8.38436 14.2282 8.54374 14.5688C8.85311 15.2282 9.35311 15.7751 9.99686 16.1469C11.7125 17.1376 13.9125 16.5469 14.9031 14.8344C15.8937 13.1219 15.3031 10.9188 13.5906 9.93131C12.325 9.20006 10.7969 9.33131 9.68436 10.1376L10.7 10.1751C11.1312 10.1907 11.4687 10.5563 11.45 10.9844C11.4344 11.4157 11.0719 11.7532 10.6406 11.7344L7.97811 11.6313C7.54686 11.6157 7.20936 11.2532 7.22811 10.8219L7.33124 8.15944C7.34686 7.72819 7.71249 7.39069 8.14061 7.40944C8.57186 7.42506 8.90936 7.78756 8.89061 8.21881L8.86874 8.79381C10.4531 7.70631 12.5937 7.55006 14.3687 8.57506C16.8281 9.99694 17.675 13.1532 16.2531 15.6126C15.3 17.2626 13.5656 18.1876 11.7812 18.1876C10.9094 18.1876 10.0219 17.9657 9.21249 17.4969C8.28749 16.9626 7.56561 16.1751 7.12499 15.2282C6.92186 14.7938 7.16874 14.2751 7.63749 14.1501Z",
    fill: "#5E6366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRestart);
export default __webpack_public_path__ + "static/media/ICON_RESTART.743610fcca3b9c84369db8089d467ed7.svg";
export { ForwardRef as ReactComponent };